import { render, staticRenderFns } from "./Healthchecks.vue?vue&type=template&id=64e12df6&scoped=true&"
import script from "./Healthchecks.vue?vue&type=script&lang=js&"
export * from "./Healthchecks.vue?vue&type=script&lang=js&"
import style0 from "./Healthchecks.vue?vue&type=style&index=0&id=64e12df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e12df6",
  null
  
)

export default component.exports